export function getAccessToken() {
  try {
    const accessToken = window.localStorage.getItem("at");
    return accessToken;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export function isAuth() {
  const at = getAccessToken();
  if (at) {
    return true;
  }
  return false;
}

export function getLS(key) {
  try {
    const data = window.localStorage.getItem(key);
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function setLS(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    console.log(error);
  }
}
